export const tasks = [
  {
    name: 'main',
    handle() {
      return new Promise(resolve => {
        // setTimeout(() => {
        //   console.log('首页需要的执行');
        //   resolve();
        // }, 3000);
        resolve();
      });
    }
  }
];

export const route = {
  redirect: 'mine/message'
};



// WEBPACK FOOTER //
// ./src/pages/home/mine/index.js